import { render, staticRenderFns } from "./Employee.vue?vue&type=template&id=0af417e0&"
import script from "./Employee.vue?vue&type=script&lang=js&"
export * from "./Employee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af417e0')) {
      api.createRecord('0af417e0', component.options)
    } else {
      api.reload('0af417e0', component.options)
    }
    module.hot.accept("./Employee.vue?vue&type=template&id=0af417e0&", function () {
      api.rerender('0af417e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/employees/Employee.vue"
export default component.exports